import { useParams, Link } from "react-router-dom";
import { plans, subjects, plandes } from "../data/plans-data";
import { Icon } from "@iconify/react";
import { PlanCard2 } from "../components/planloader";
import scrollToTop from "../components/scrolltotop";

function PlansInfo() {
  const { planKey } = useParams();
  const plan = plans[planKey];
  const baseId = plan.id.split("-")[0];

  if (!plan) return <h1>Plan not found</h1>;

  const resolvedSubjects = plan.subjects.map((id) => subjects[id]);

  return (
    <div className="plans-info-page-container">
      <div className="sect">
        <h1 className="title">{plan.name}</h1>
        <p className="description">{plandes[baseId]}</p>
      </div>

      <div className="subjectlist">
        <h3>This course includes the following subjects:</h3>
        <div className="card-cont">
          {resolvedSubjects.map((subject) => (
            <div key={subject.label} className="card">
              <div className="line">
                <div className="dots">
                  <span
                    className="dot"
                    style={{ backgroundColor: subject.lcolor }}
                  />
                </div>
                <p className="label">
                  <strong>{subject.label}</strong>
                </p>
              </div>
              <p className="des">{subject.description}</p>
            </div>
          ))}
        </div>
      </div>

      {plan.blend && (
        <div className="blend">
          <h3>The subject blend</h3>
          <p>{plan.blend}</p>
        </div>
      )}

      <div className="teach">
        <h3>How we teach it</h3>
        <div className="point-container">
          <div className="point">
            <div className="iconcont">
              <Icon className="iconimg" icon="ri-presentation-fill" />
            </div>
            <p>
              Each lesson will be delivered with a detailed presentation that
              introduce concepts in a digestible manner, and prompts students to
              practice new skills.
            </p>
          </div>
          <div className="point">
            <div className="iconcont">
              <Icon className="iconimg" icon="foundation-page-filled" />
            </div>
            <p>
              After each lesson, students will gain access to a tutorial sheet
              for that lesson that contains key concepts they can refer for
              revision
            </p>
          </div>
          <div className="point">
            <div className="iconcont">
              <Icon className="iconimg" icon="foundation-page" />
            </div>
            <p>
              Students will be assigned worksheets relating to the topics
              they’ve been taught to ensure they have grasped the concepts.
              These will be assigned after the lesson, and at later times to
              further reinforce concepts
            </p>
          </div>
        </div>
      </div>
      <div className="optcont">
        <h3>Plan options</h3>
        <div className="opt-scroll">
          <div className="opt">
            {Object.values(plans)
              .filter((p) => p.id.split("-")[0] === baseId)
              .map((p) => (
                <PlanCard2 key={p.id} planKey={p.id} />
              ))}
          </div>
        </div>
      </div>

      <Link to="/courses" className="btn alt back" onClick={scrollToTop}>
        Back to plans
      </Link>
    </div>
  );
}

export default PlansInfo;
